import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FigmaCleanupReportDto } from "../api/models/figmaCleanupModels";

interface FigmaCleanupReportsGridProps {
    reports: FigmaCleanupReportDto[];
}

const FigmaCleanupReportsGrid = ({ reports }: FigmaCleanupReportsGridProps) => {
    const navigate = useNavigate();

    const columns: GridColDef[] = [
        {
            field: "completedDate",
            headerName: "Completed Date",
            width: 200,
            valueFormatter: (params) => {
                if (!params.value) return "";
                return new Date(params.value).toLocaleString();
            },
        },
        {
            field: "totalUsersInCsv",
            headerName: "Total Users",
            width: 120,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "usersWarned",
            headerName: "Warned",
            width: 100,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value > 0 ? "warning" : "default"}
                    size="small"
                />
            ),
        },
        {
            field: "usersRemoved",
            headerName: "Removed",
            width: 100,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value > 0 ? "error" : "default"}
                    size="small"
                />
            ),
        },
        {
            field: "skipped",
            headerName: "Skipped",
            width: 100,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "errors",
            headerName: "Errors",
            width: 100,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value > 0 ? "error" : "success"}
                    size="small"
                />
            ),
        },
    ];

    const handleRowClick = (params: any) => {
        navigate(`/admin/operations/${params.row.id}`);
    };

    return (
        <Box sx={{ height: 500, width: "100%" }}>
            <DataGrid
                rows={reports}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "completedDate", sort: "desc" }],
                    },
                }}
                onRowClick={handleRowClick}
                autoHeight
                sx={{
                    "& .MuiDataGrid-row": {
                        cursor: "pointer",
                    },
                    "& .MuiDataGrid-row:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                }}
            />
        </Box>
    );
};

export default FigmaCleanupReportsGrid;
